module.exports = ".red {\n    color: #fc0707;\n}\n\n.containerTotais {\n    padding: 0;\n}\n\n.containerRelative {\n    position: relative;\n}\n\n.containerRelative a {\n    position: absolute;\n    right: -13px;\n    top: -38px;\n}\n\n.containerAjuste {\n    margin: 1rem;\n}\n\n.borderTop {\n    border-top: 1px solid #edf0f4;\n}\n\n.containerAjuste p.lead {\n    padding-left: 12px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/bombas/bomba-auditoria/bomba-auditoria.component.css
 ** module id = 570
 ** module chunks = 0
 **/